import React from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import ModalContainer from "components/ModalContainer";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";

const SnapshotModal = ({ open, snapshot, onClose, onSave }) => {
  return (
    <ModalContainer display={open} modalWidth="500px">
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontSize: "18px", fontWeight: "bold", color: "#172664" }}>
            Snapshot
          </Typography>
          <IconButton onClick={onClose} aria-label="Close snapshot dialog" sx={{ p: 0.5 }}>
            <CloseOutlined style={{ fontSize: "18px", color: "rgba(0,0,0,0.45)" }} />
          </IconButton>
        </Stack>
        <Box
          component="img"
          src={snapshot || ""}
          alt="Camera snapshot"
          sx={{
            display: "block",
            width: "100%",
            maxHeight: "60vh",
            objectFit: "contain",
            backgroundColor: "#666",
            borderRadius: 1,
          }}
        />
        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <OutlineButton width="90px" height="36px" onClick={onClose}>
            Cancel
          </OutlineButton>
          <SolidButton width="90px" height="36px" onClick={onSave}>
            Save
          </SolidButton>
        </Stack>
      </Stack>
    </ModalContainer>
  );
};

export default SnapshotModal;
